import React from 'react';

import OrganizationLink from 'src/common/OrganizationLink';
import { AnalyticsStrongIcon } from 'src/monet/icons';
import { useEditorContext } from 'src/store/editor';

export const EditorHeaderInsightsButton = () => {
  const uuid = useEditorContext((state) => state.journey.uuid);

  return (
    <OrganizationLink to={`/insights/journeys/${uuid}`}>
      <button type='button' className='has-hover py-[9px] px-md pitch-onboarding-insights'>
        <div className='flex items-center space-x-xs'>
          <AnalyticsStrongIcon />
          <span className='text-bedrock-p-strong'>Insights</span>
        </div>
      </button>
    </OrganizationLink>
  );
};
